import type { ISubcontractorPortalData } from '@interfaces/ISubcontractorPortal';

export const MOCK_SUBCONTRACTOR_PORTAL: ISubcontractorPortalData = {
  subcontractor: {
    id: 'sc-kotetsu-001',
    name: 'Kotetsu Steel Works',
    status: 'on-track',
    scope: 'Rebar installation & steel erection — Levels 10–15',
    location: { zone: 'A', level: 14 },
    workforceCount: 12,
    leadName: 'Tanaka Hiroshi',
    progressPercent: 68,
    milestone: 'Level 15 rebar complete',
    milestoneDate: '2026-05-28',
  },
  tasks: [
    {
      id: 't-001',
      title: 'Rebar cage installation — Column C3',
      status: 'in-progress',
      date: '2026-05-18',
      timeWindow: '07:00–12:00',
      location: 'Zone A · L14',
    },
    {
      id: 't-002',
      title: 'Rebar cage installation — Column C4',
      status: 'scheduled',
      date: '2026-05-18',
      timeWindow: '12:30–15:30',
      location: 'Zone A · L14',
    },
    {
      id: 't-003',
      title: 'Material staging for Level 15 pour',
      status: 'staging',
      date: '2026-05-19',
      timeWindow: '08:00–10:00',
      location: 'Zone B · Yard',
    },
    {
      id: 't-004',
      title: 'Level 13 rebar inspection',
      status: 'completed',
      date: '2026-05-17',
      timeWindow: '14:00–15:00',
      location: 'Zone A · L13',
    },
  ],
  alerts: [
    {
      id: 'al-001',
      title: 'Rebar spacing deviation — Column C3',
      body: 'Spacing mismatches Rev. 4 drawing. Pending engineer confirmation.',
      severity: 'high',
      raisedAt: '2026-05-18T08:42:00+09:00',
      actionLabel: 'Submit RFI response',
    },
  ],
  recentUpdates: [
    {
      id: 'ru-001',
      title: 'Level 13 pour completed',
      body: 'Pour passed inspection. 142 m³ placed, 0 defects logged.',
      timestamp: '2026-05-18T06:30:00+09:00',
    },
    {
      id: 'ru-002',
      title: 'Material delivery — Bay 2',
      body: '12 t SD345 rebar received and staged for Level 14.',
      timestamp: '2026-05-17T16:10:00+09:00',
    },
  ],
  documents: [
    {
      id: 'd-001',
      code: 'S-14-01',
      title: 'Level 14 Rebar Layout',
      revision: 'Rev C',
      date: '2026-05-12',
      isNew: true,
    },
    {
      id: 'd-002',
      code: 'S-14-02',
      title: 'Column Connection Detail',
      revision: 'Rev B',
      date: '2026-05-09',
    },
    {
      id: 'd-003',
      code: 'PROC-007',
      title: 'Rebar Installation Procedure',
      revision: 'v2.1',
      date: '2026-05-01',
    },
    {
      id: 'd-004',
      code: 'PHOTO-013',
      title: 'Level 13 Completion Photos',
      revision: '—',
      date: '2026-05-11',
    },
  ],
  workforce: {
    count: 4,
    averagePerformance: 78,
    flaggedCount: 2,
    workers: [
      {
        id: 'w-001',
        initials: 'TH',
        name: 'Tanaka Hiroshi',
        role: 'Foreman · Steel Erector',
        level: 'Expert',
        experienceYears: 18,
        performance: 92,
      },
      {
        id: 'w-002',
        initials: 'SA',
        name: 'Suzuki Aoi',
        role: 'Steel Erector',
        level: 'Senior',
        experienceYears: 9,
        performance: 86,
      },
      {
        id: 'w-003',
        initials: 'WK',
        name: 'Watanabe Ken',
        role: 'Welder',
        level: 'Mid',
        experienceYears: 5,
        performance: 74,
        flagged: true,
      },
      {
        id: 'w-004',
        initials: 'YR',
        name: 'Yamamoto Ryo',
        role: 'Apprentice',
        level: 'Junior',
        experienceYears: 1,
        performance: 58,
        flagged: true,
      },
    ],
  },
  messages: [
    {
      id: 'm-001',
      fromInitials: 'KT',
      fromName: 'Koji Tanaka',
      fromRole: 'Site Manager',
      timestamp: '2026-05-18T08:15:00+09:00',
      body: 'Please confirm column spacing on C3 before the inspector arrives at 10:00.',
      needsResponse: true,
    },
    {
      id: 'm-002',
      fromInitials: 'SC',
      fromName: 'Sato Chiaki',
      fromRole: 'Precision HVAC',
      timestamp: '2026-05-18T09:30:00+09:00',
      body: 'When will the ceiling grid clearance be ready on Level 14? We are queued for tomorrow.',
      needsResponse: true,
    },
    {
      id: 'm-003',
      fromInitials: 'MR',
      fromName: 'Mori Ren',
      fromRole: 'QA Inspector',
      timestamp: '2026-05-17T17:40:00+09:00',
      body: 'Level 13 inspection completed — no findings. Report uploaded.',
      needsResponse: false,
    },
  ],
};
